import React from 'react';
import RegistrationHeader from './components/RegistrationHeader';
import RegistrationForm from './components/RegistrationForm';
import SocialRegistration from './components/SocialRegistration';
import LoginPrompt from './components/LoginPrompt';

const Register = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-12 lg:py-16">
        <div className="max-w-md mx-auto">
          <div className="bg-card rounded-xl md:rounded-2xl lg:rounded-3xl shadow-lg border border-border p-6 md:p-8 lg:p-10">
            <RegistrationHeader />
            <RegistrationForm />
            <SocialRegistration />
            <LoginPrompt />
          </div>

          <div className="mt-6 md:mt-8 text-center">
            <p className="caption text-muted-foreground">
              By creating an account, you agree to our{' '}
              <button className="text-primary hover:underline">Terms of Service</button>
              {' '}and{' '}
              <button className="text-primary hover:underline">Privacy Policy</button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;